export default [
  [
    {
      id: 'companyName',
      label: 'ชื่อบริษัท',
      span: 16,
      type: 0,
      props: { padding: '8px 0', title: { text: 'ชื่อบริษัท *' } },
    }, {
      id: 'branch',
      label: 'สาขา',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'สาขา' } },
    }, {
      id: 'credit',
      label: 'เครดิต',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'เครดิต *' } },
    }, {
      id: 'taxId',
      label: 'เลขประจำตัวผู้เสียภาษี',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'เลขประจำตัวผู้เสียภาษี' } },
    }, {
      id: 'groupId',
      label: 'กลุ่มบริษัท',
      span: 8,
      type: 6,
      props: { padding: '8px 0', title: { text: 'กลุ่มบริษัท' } },
    }, {
      id: 'cargoType',
      label: 'ประเภทสินค้า *',
      span: 24,
      type: 7,
      props: { padding: '8px 0' },
    },
  ], [
    {
      id: 'typeOfChargeId',
      label: 'ประเภทบริษัท *',
      span: 24,
      type: 4,
      list: [{ value: 1, label: 'ผู้จ้าง VIP' }, { value: 2, label: 'ผู้จ้างประจำ' }, { value: 3, label: 'ผู้จ้างทั่วไป' }],
      isVertical: false,
    }, {
      id: 'rateType',
      label: 'ประเภทการคิดเงิน *',
      span: 24,
      type: 4,
      list: [{ value: 'START', label: 'ต้นทาง' }, { value: 'END', label: 'ปลายทาง' }, { value: 'MIN', label: 'น้ำหนักน้อย' }, { value: 'ETC', label: 'อื่นๆ' }],
      isVertical: false,
    },
  ], [
    {
      id: 'companyAddress',
      span: 24,
      type: 0,
      props: { padding: '8px 0', title: { text: 'ที่อยู่' } },
    }, {
      id: 'officeNumber',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'เบอร์ออฟฟิศ' } },
    }, {
      id: 'contactName',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'ชื่อผู้ติดต่อ' } },
    }, {
      id: 'contactNumber',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'เบอร์มือถือ' } },
    }, {
      id: 'email',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'อีเมล' } },
    }, {
      id: 'fax',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'โทรสาร' } },
    }, {
      id: 'websiteUrl',
      span: 8,
      type: 0,
      props: { padding: '8px 0', title: { text: 'เว็บไซต์' } },
    }, {
      id: 'note',
      span: 24,
      type: 0,
      props: { padding: '8px 0', title: { text: 'โน้ต' } },
    }, {
      id: 'images',
      span: 24,
      type: 5,
      props: { margin: '8px 0' },
    },
  ],
]
